import { TagBar } from './TagBar'

export default TagBar
